// extracted by mini-css-extract-plugin
module.exports = {"HeroSimple":"HeroSimple_HeroSimple__mo_9x","paragraph":"HeroSimple_paragraph__28azf","cta":"HeroSimple_cta__YsETt"};